import { SubmitHandler } from "react-hook-form";

import {
    IClubhouseTeamLFPData,
    LFPHandlersProps,
} from "../types/lookingforplayers";

import { alertActions } from "../../../../../features/alert/alertSlice";
import { selectSelectedTeam } from "../../../../../features/clubhouse/clubhouseSlice";
import {
    useAppDispatch,
    useAppSelector,
} from "../../../../../hooks/reduxHooks";
import { deleteLooking, updateLFP } from "../../../../../lib/api";

const useLFPHandlers = ({
    setShow,
    setSending,
    setLooking,
    setLookingList,
    methods,
}: LFPHandlersProps) => {
    const dispatch = useAppDispatch();
    const selectedTeam = useAppSelector(selectSelectedTeam);
    const { user } = useAppSelector(state => state.auth);

    const handleSubmit: SubmitHandler<IClubhouseTeamLFPData> = async data => {
        setSending(true);
        try {
            const { looking } = await updateLFP(data, selectedTeam!.id);

            dispatch(
                alertActions.success({
                    title: "Request submitted successfully",
                    dismissible: true,
                }),
            );

            setLooking(looking.find(t => t.id === selectedTeam?.id));

            if (setLookingList) {
                setLookingList(looking);
            }
        } catch (error: any) {
            dispatch(
                alertActions.error({
                    title: "The was a problem submitting the request.",
                    text: error,
                    dismissible: true,
                }),
            );
        } finally {
            setSending(false);
        }
    };

    const handleDelete: React.MouseEventHandler<
        HTMLButtonElement
    > = async () => {
        setSending(true);
        setShow(false);
        try {
            const { looking } = await deleteLooking(selectedTeam!.id, user!.id);

            dispatch(
                alertActions.success({
                    title: "Tryout info deleted successfully",
                    dismissible: true,
                }),
            );

            setLooking(undefined);
            methods.reset(undefined);

            if (setLookingList) {
                setLookingList(looking);
            }
        } catch (error: any) {
            dispatch(
                alertActions.error({
                    title: "The was a problem deleting the request.",
                    text: error,
                    dismissible: true,
                }),
            );
        } finally {
            setSending(false);
        }
    };
    return { handleSubmit, handleDelete };
};

export default useLFPHandlers;
